module.exports = __webpack_public_path__ + "static/img/videoCover1.aaed4aa0.png";